import React, { useRef, useEffect } from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
  Title,
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend, Title);

const PagosPorMesChart = ({ pagos = [] }) => {
  const chartRef = useRef(null);

  // Crear degradado dinámico cuando se renderiza
  useEffect(() => {
    const chart = chartRef.current;
    if (!chart) return;
    const ctx = chart.ctx;

    chart.update(); // Solo actualizar el chart después de render
  }, [pagos]);

  // Asegurar 12 meses del año actual
  const currentYear = new Date().getFullYear();
  const meses = Array.from({ length: 12 }, (_, i) => i + 1);

  // Mapear pagos por mes para lookup
  const pagosPorMes = {};
  pagos.forEach((p) => {
    pagosPorMes[p.month] = p.total || 0;
  });

  const labels = meses.map((m) => `${m}/${currentYear}`);
  const datos = meses.map((m) => pagosPorMes[m] || 0);

  const data = {
    labels,
    datasets: [
      {
        label: "Pagos",
        data: datos,
        borderRadius: 8,
        barThickness: 20,        // ancho fijo (más delgado)
        maxBarThickness: 30,     // ancho máximo
        categoryPercentage: 0.6,
        barPercentage: 0.8,
        backgroundColor: function (context) {
          const chart = context.chart;
          const ctx = chart.ctx;
          const gradient = ctx.createLinearGradient(0, 0, 0, 300);
          gradient.addColorStop(0, "#4e73df");
          gradient.addColorStop(1, "#1cc88a");
          return gradient;
        },
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      title: {
        display: true,
        text: "Pagos por Mes",
        font: { size: 18, weight: "bold" },
        padding: { top: 10, bottom: 30 },
      },
      legend: {
        position: "bottom",
        labels: { font: { size: 14 } },
      },
      tooltip: {
        backgroundColor: "#1cc88a",
        titleColor: "#fff",
        bodyColor: "#fff",
        callbacks: {
          label: (context) => `${context.dataset.label}: $${context.raw}`,
        },
      },
    },
    scales: {
      x: { stacked: true, grid: { display: false } },
      y: {
        stacked: true,
        ticks: { callback: (value) => `$${value}` },
        grid: { color: "#f1f1f1" },
      },
    },
  };

  return <Bar ref={chartRef} data={data} options={options} />;
};

export default PagosPorMesChart;